"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _utils = require("@site/utils");
const SupportPhone = ({
  textId = 'phoneForHelp',
  textValueKey = 'phone',
  cssClasses = 'text-muted ms-1 ml-1',
  isAuctionDomain = false,
  auctionPhone,
  premiumPhone
}) => {
  const supportPhone = isAuctionDomain ? auctionPhone : premiumPhone;
  const market = (0, _utils.getMarket)();
  const showSupportPhone = !_utils.MarketHelper.isPhoneHiddenMarket(market) && supportPhone;
  return showSupportPhone && /*#__PURE__*/_react.default.createElement("span", {
    className: cssClasses,
    "data-cy": "support-phone",
    "data-testid": "support-phone"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: textId,
    values: {
      [textValueKey]: supportPhone
    }
  }));
};
SupportPhone.propTypes = {
  isAuctionDomain: _propTypes.default.bool,
  cssClasses: _propTypes.default.string,
  textId: _propTypes.default.string,
  textValueKey: _propTypes.default.string,
  auctionPhone: _propTypes.default.string,
  premiumPhone: _propTypes.default.string
};
var _default = exports.default = SupportPhone;